import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, message, Popconfirm, Select } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import {
  getClientDepartments,
  createClientDepartment,
  updateClientDepartment,
  deleteClientDepartment
} from '../api';

const { Option } = Select;

const ClientDepartments = ({ clientId, onBack }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form] = Form.useForm();

  const fetchDepartments = async () => {
    setLoading(true);
    const res = await getClientDepartments(clientId);
    setLoading(false);
    if (res.success) {
      setDepartments(res.data);
    } else {
      message.error(res.message || 'Failed to fetch departments');
    }
  };

  useEffect(() => {
    if (clientId) fetchDepartments();
  }, [clientId]);

  const openModal = (record = null) => {
    setEditing(record);
    setModalVisible(true);
    if (record) {
      form.setFieldsValue(record);
    } else {
      form.resetFields();
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      values.client_id = clientId;
      let res;
      if (editing) {
        res = await updateClientDepartment(editing.id, values);
      } else {
        res = await createClientDepartment(values);
      }
      if (res.success) {
        message.success(editing ? 'Department updated' : 'Department created');
        setModalVisible(false);
        fetchDepartments();
      } else {
        message.error(res.message || 'Operation failed');
      }
    } catch (err) {
      // Validation error
    }
  };

  const handleDelete = async (id) => {
    const res = await deleteClientDepartment(id);
    if (res.success) {
      message.success('Department deleted');
      fetchDepartments();
    } else {
      message.error(res.message || 'Delete failed');
    }
  };

  const columns = [
    {
      title: 'S.No',
      key: 'sno',
      width: 60,
      render: (_, __, index) => index + 1
    },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 100 },
    {
      title: 'Actions',
      key: 'actions',
      width: 160,
      render: (_, record) => (
        <>
          <Button icon={<EditOutlined />} size="small" style={{ marginRight: 8 }} onClick={() => openModal(record)} />
          <Popconfirm title="Are you sure to delete this department?" onConfirm={() => handleDelete(record.id)} okText="Yes" cancelText="No">
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <Button icon={<ArrowLeftOutlined />} style={{ marginBottom: 16 }} onClick={onBack}>Back to Clients</Button>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h2>Client Departments</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()}>Add Department</Button>
      </div>
      <Table rowKey="id" columns={columns} dataSource={departments} loading={loading} bordered />
      <Modal
        title={editing ? 'Edit Department' : 'Add Department'}
        open={modalVisible}
        onOk={handleOk}
        onCancel={() => setModalVisible(false)}
        okText={editing ? 'Update' : 'Create'}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please enter name' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Description">
            <Input />
          </Form.Item>
          <Form.Item name="status" label="Status" initialValue="active">
            <Select>
              <Option value="active">Active</Option>
              <Option value="inactive">Inactive</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ClientDepartments; 